module.exports = __webpack_public_path__ + "static/media/undo.bcbfbe44.ico";